import { useIntl } from '@lumahealthhq/ui-components/hooks';
export default function useIntlEmptyContentMessages(search) {
  const intl = useIntl();
  const messages = {
    emptyState: {
      title: intl.formatMessage({
        id: "KOrUOv",
        defaultMessage: [{
          "type": 0,
          "value": "You’re all caught up."
        }]
      }),
      subtitle: intl.formatMessage({
        id: "9ZXtkh",
        defaultMessage: [{
          "type": 0,
          "value": "When something needs your attention, it’ll appear here."
        }]
      })
    },
    searchState: {
      title: intl.formatMessage({
        id: "yal2AA",
        defaultMessage: [{
          "type": 0,
          "value": "No results for “"
        }, {
          "type": 1,
          "value": "search"
        }, {
          "type": 0,
          "value": "”"
        }]
      }, {
        search
      }),
      subtitle: intl.formatMessage({
        id: "qmOBNv",
        defaultMessage: [{
          "type": 0,
          "value": "Try changing your search terms."
        }]
      })
    },
    filterState: {
      title: intl.formatMessage({
        id: "jHJmjf",
        defaultMessage: [{
          "type": 0,
          "value": "No results"
        }]
      }),
      subtitle: intl.formatMessage({
        id: "EG6VYE",
        defaultMessage: [{
          "type": 0,
          "value": "Try changing your filters."
        }]
      })
    }
  };
  return messages;
}